import React from "react";

export default function OrderPlaced({ opacity, zIndex }) {
  return (
    <div
      className="placed d-flex flex-column align-items-center justify-content-center"
      id="orderPlaced"
      style={{
        opacity: opacity || 0,
        zIndex: zIndex,
      }}
    >
      <i className="bi bi-check-circle fs-xxl text-white" id="check"></i>
      <div className="fs-lg text-center text-white fw-bold lh-sm" id="text">
        Order <br /> Placed
      </div>
      <div className="pad"></div>
      <div className="pad"></div>
    </div>
  );
}
